import React, { useEffect, useRef, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import { getroledata } from "service/myapi"
import usePermissions from "withpermission";
import { addAudittrial, getClinicById } from "service/api";
import { jwtDecode } from "jwt-decode";

const SidebarUser = props => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }
  const { allpermission, isAdmin } = usePermissions();

  const [isadmin, setIsAdmin] = useState(false);
  const [userId, setUserId] = useState(null);
  const [clinicID, setclinicID] = useState(null);
  const [Image, setLogoUrl] = useState(null);
  const [username, setusername] = useState(null);
  const [token, setToken] = useState(null);
  const [Role, Setuserrole] = useState(null);
  const [Clinicsname, Setclinicname] = useState(null);
  const [alluserlist, setallusers] = useState({ users: [] })



  useEffect(() => {
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    };

    const myrole = getCookie('userType');
    // console.log('User role:', myrole);
    if (myrole === 'admin') {
      setIsAdmin(true);
    }
    Setuserrole(myrole);

    // console.log('User role:', myrole);

    const storedToken = localStorage.getItem('token');
    setToken(storedToken);
    // console.log('Token from LocalStorage:', storedToken);
    if (storedToken) {
      try {
        const decodedToken = jwtDecode(storedToken);
        setUserId(decodedToken.userId);
        // console.log('UserID from Token:', decodedToken.userId);
        setusername(decodedToken.username);
        // console.log('UserID from Token:', decodedToken.username);
        setclinicID(decodedToken.clinicID);
        // console.log('UserID from Token:', decodedToken.clinicID);
      } catch (error) {
        console.error('Failed to decode token:', error);
      }
    }
    fetchData();
  }, []);

  const fetchData = async () => {
    if (clinicID) {
      try {
        const response = await getClinicById(clinicID); // Fetch clinic data
        setallusers(response.data);

        if (response.data && response.data.name) {
          Setclinicname(response.data.name)
          // console.log('Clinic Name:', response.data.name);

          // Extract image name from the logo path
          const logoPath = response.data.logo;
          const imageName = logoPath.split('\\').pop();
          // console.log('Extracted Image Name:', imageName);

          const imageResponse = await getImage(imageName);
          if (imageResponse) {
            const imageUrl = URL.createObjectURL(imageResponse.data);
            setLogoUrl(imageUrl);
          }
        } else {
          console.log('Clinic data does not contain a name field');
        }
      } catch (error) {
        console.error('Failed to fetch clinic data:', error);
      }
    } else {
      console.error('No clinicID available to fetch data');
    }
  };

  useEffect(() => {
    fetchData();
  }, [clinicID]);

  // Function to log the user action for audit trail

  // const logUserAction = async (action, resource) => {
  //   const ipAddress = await fetch('https://api.ipify.org?format=json')
  //     .then(response => response.json())
  //     .then(data => data.ip)
  //     .catch(error => {
  //       console.error('Failed to fetch IP address:', error);
  //       return 'unknown';
  //     });
  //   console.log('User IP Address:', ipAddress);

  //   const auditData = {
  //     action,
  //     resource,
  //     userid: userId,
  //     userName: username,
  //     timestamp: new Date(),
  //     ipAddress,
  //   };

  //   fetch('/api/audit-trail', {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify(auditData),
  //   }).then(response => {
  //     if (!response.ok) {
  //       console.error('Failed to log user action');
  //     }
  //   }).catch(error => {
  //     console.error('Error logging user action:', error);
  //   });
  // };
  const getBrowserName = () => {
    const userAgent = navigator.userAgent;

    // Regular expression to extract browser name
    const browserRegex = /(Opera|OPR|Edg|Chrome|Safari|Firefox|MSIE|Trident)/;

    // Execute the regex against the user agent string
    const match = userAgent.match(browserRegex);

    if (match) {
      const matchedName = match[0];

      // Handle specific cases
      if (matchedName === 'Chrome' && /Edg/.test(userAgent)) {
        return 'Edge';
      }
      if (matchedName === 'Safari' && /Chrome/.test(userAgent)) {
        return 'Chrome';
      }
      if (matchedName === 'OPR') {
        return 'Opera';
      }
      if (matchedName === 'Trident' || matchedName === 'MSIE') {
        return 'Internet Explorer';
      }

      return matchedName;
    }

    return 'Unknown';
  };

  const logUserAction = async (action, resource) => {
    try {
      const ipAddress = await fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => data.ip)
        .catch(error => {
          console.error('Failed to fetch IP address:', error);
          return 'unknown';
        });
      const agent = getBrowserName();

      const auditData = {
        action,
        resource,
        userid: userId,
        userName: username,
        timestamp: new Date(),
        ipAddress,
        agent,
        role: Role,
        clinic: Clinicsname,
      };

      const response = await addAudittrial(auditData);

      if (response.status !== 201) {
        console.error('Failed to log user action');
      } else {
        console.log('User action logged successfully');
      }
    } catch (error) {
      console.error('Error logging user action:', error);
    }
  };

  // Example of how to call logUserAction
  const handleLinkClick = (e, resource) => {
    logUserAction('click', resource);
  };

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            <li>
              <Link to="/dashboard">{props.t("Dashboard")}</Link>
            </li>

            <li className="menu-title">{props.t("Manage Reception")}</li>

            {allpermission.includes("Appointment") && (
              <li>
                <Link to="/Appointment" >
                  <i className="bx bx-edit"></i>
                  <span>{props.t("Appointment")}</span>
                </Link>
              </li>
            )}

            <li className="menu-title">{props.t("Patient Rgistration")}</li>


            {allpermission.includes("Addpatient") && (
              <li>
                <Link to="/Addpatient" onClick={(e) => handleLinkClick(e, "Add New Patient")}>
                  <i className="bx bx-folder-open"></i>
                  <span>{props.t("Add New Patient")}</span>
                </Link>
              </li>
            )}
            {allpermission.includes("Addvisit") && (
              <li>
                <Link to="/Addvisit" onClick={(e) => handleLinkClick(e, "Add New Vist")}>
                  <i className="bx bx-folder-open"></i>
                  <span>{props.t("Add New Vist")}</span>
                </Link>
              </li>
            )}

            <li className="menu-title">{props.t("Consultation")}</li>

            {allpermission.includes("Addpatientcare") && (
              <li>
                <Link to="/Addpatientcare" onClick={(e) => handleLinkClick(e, "Patient Care")}>
                  <i className="bx bx-folder-open"></i>
                  <span>{props.t("Patient Care")}</span>
                </Link>
              </li>
            )}

            <li className="menu-title">{props.t("Eyewear")}</li>
            {allpermission.includes("takeframe") && (
              <li>
                <Link to="/takeframe" onClick={(e) => handleLinkClick(e, "Frames")}>
                  <i className="bx bx-folder-open"></i>
                  <span>{props.t("Frames")}</span>
                </Link>
              </li>
            )}
            {allpermission.includes("takelense") && (
              <li>
                <Link to="/takelense" onClick={(e) => handleLinkClick(e, "Lenses")}>
                  <i className="bx bx-folder-open"></i>
                  <span>{props.t("Lenses")}</span>
                </Link>
              </li>
            )}

            <li className="menu-title">{props.t("Laboratory")}</li>

            {allpermission.includes("addJobform") && (
              <li>
                <Link to="/addJobform" onClick={(e) => handleLinkClick(e, "Register Job")}>
                  <i className="bx bx-folder-open"></i>
                  <span>{props.t("Register Job")}</span>
                </Link>
              </li>
            )}
            {allpermission.includes("Addlab") && (
              <li>
                <Link to="/Addlab" onClick={(e) => handleLinkClick(e, "Lab Order Form")}>
                  <i className="bx bx-folder-open"></i>
                  <span>{props.t("Lab Order Form")}</span>
                </Link>
              </li>
            )}

            <li className="menu-title">{props.t("Billing")}</li>

            {allpermission.includes("accounts") && (
              <li>
                <Link to="/accounts" onClick={(e) => handleLinkClick(e, "Generate Invoice")}>
                  <i className="bx bx-folder-open"></i>
                  <span>{props.t("Generate Invoice")}</span>
                </Link>
              </li>
            )}
            {allpermission.includes("AddUser") && (
              <li>
                <Link to="/AddUser" onClick={(e) => handleLinkClick(e, "Add Staff")}>
                  <i className="bx bx-folder-open"></i>
                  <span>{props.t("Add Staff")}</span>
                </Link>
              </li>
            )}
            {allpermission.includes("Users") && (
              <li>
                <Link to="/Users" onClick={(e) => handleLinkClick(e, "Staff List")}>
                  <i className="bx bx-folder-open"></i>
                  <span>{props.t("Staff List")}</span>
                </Link>
              </li>
            )}
            {allpermission.includes("Audittrial") && (
              <li>
                <Link to="/Audittrial" onClick={(e) => handleLinkClick(e, "Audit trial")}>
                  <i className="bx bx-folder-open"></i>
                  <span>{props.t("Audit trial")}</span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarUser.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarUser));
